import { jsx as _jsx } from "react/jsx-runtime";
export const renderLeaf = ({ attributes, children, leaf }) => {
    const style = {
        fontSize: leaf.fontSize,
        color: leaf.color,
        fontFamily: leaf.fontFamily
    };
    if (leaf.bold) {
        children = _jsx("strong", { ...attributes, children: children });
    }
    if (leaf.italic) {
        children = _jsx("em", { ...attributes, children: children });
    }
    if (leaf.code) {
        children = _jsx("code", { ...attributes, children: children });
    }
    if (leaf.strikeThrough) {
        children = _jsx("del", { ...attributes, children: children });
    }
    if (leaf.underline) {
        children = _jsx("u", { ...attributes, children: children });
    }
    return (_jsx("span", { ...attributes, style, children: children }));
};
